import FilePreview from './FilePreview.component';

export default FilePreview;